// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

let RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");

let Types = {};

let fragmentConverter = {"__root":{"":{"f":""}}};

function convertFragment(v) {
  return RescriptRelay.convertObj(v, fragmentConverter, undefined, undefined);
}

let Internal = {
  fragmentConverter: fragmentConverter,
  fragmentConverterMap: undefined,
  convertFragment: convertFragment
};

let Utils = {};

let node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "MyClientsWidgetSeller_seller",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "MyClientsWidgetSeller_name_seller"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "MyClientsWidgetSeller_status_seller"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "MyClientsWidgetSeller_Menu_seller"
    }
  ],
  "type": "Seller",
  "abstractKey": null
};

exports.Types = Types;
exports.Internal = Internal;
exports.Utils = Utils;
exports.node = node;
/* RescriptRelay Not a pure module */
